import { css, html, LitElement, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '../../library/editors/elements/d-checkbox.js';
import '../../library/editors/elements/d-select-dropdown.js';
import type { ReminderType } from './reminder-type';
import { reminderOptions } from '../../store/data/reminder-options';

/**
 *
 */
@customElement('d-edit-reminder')
export class DEditReminder extends LitElement {
  static readonly styles = css`
    :host {
      display: flex;
      flex-direction: row;
    }

    d-select-dropdown {
      width: 160px;
      margin-top: 0;
      margin-left: 10px;
    }
  `;

  @property({ type: String })
  value: ReminderType = 'NONE';
  @property({ type: Boolean })
  disabled = false;

  private get reminder() {
    return this.value !== 'NONE' && !this.disabled;
  }

  render() {
    return html`
      <d-checkbox
        ?checked=${this.reminder}
        ?disabled=${this.disabled}
        option-field="tasks_reminder"
        @checked-changed=${this.onCheckChanged}
      ></d-checkbox>

      ${this.reminder
        ? html`<d-select-dropdown
            .value=${this.value}
            .options=${reminderOptions}
            @value-changed=${this.onOptionChanged}
          ></d-select-dropdown> `
        : nothing}
    `;
  }

  private onCheckChanged(e: CustomEvent<{ checked: boolean }>) {
    e.stopPropagation();
    if (e.detail.checked) {
      this.value = 'AT_START';
    } else {
      this.value = 'NONE';
    }

    this.dispatchEvent(
      new CustomEvent<{ value: ReminderType }>('value-changed', {
        bubbles: true,
        composed: true,
        detail: { value: this.value },
      }),
    );
  }

  private onOptionChanged(e: CustomEvent<{ value: string }>) {
    e.stopPropagation();
    this.value = e.detail.value as ReminderType;
    this.dispatchEvent(
      new CustomEvent<{ value: ReminderType }>('value-changed', {
        bubbles: true,
        composed: true,
        detail: { value: this.value },
      }),
    );
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'd-edit-reminder': DEditReminder;
  }
}
